export default "__VITE_ASSET__C9lo1O6z__"